import $ from 'jquery';

export default function () {

  const isLarge = window.innerWidth >= 800;

  // contain
  $('.js-contain').each( function(idx, el) {

    const $child = $(el);

    // parent sizes and ratios
    const $parent = $child.parent();
    const w = $parent.width();
    const h = $parent.height();
    const ratio = w/h;

    // child sizes and ratios
    const zoomInBoundsAttr = (window.innerWidth < 800 ) ? 'bounds-rect-mobile' : 'bounds-rect';
    const bounds = $child.hasClass('zoom') ? $child.data(zoomInBoundsAttr).split(',') : window.zoomBounds;

    const maxSizesAttr = (window.innerWidth < 800 ) ? 'max-sizes-mobile' : 'max-sizes';
    const maxSizes = $child.data(maxSizesAttr).split(',');
    const maxW = maxSizes[0];
    const maxH = maxSizes[1];


    const origChildRatio = bounds[2] / bounds[3];

    // if screen ratio > child ratio.... use height
    // if screen ratio < child ratio.... use width

    const childW = bounds[2];//(isLarge) ? $child.data('large-w') : $child.data('small-w');
    const childH = bounds[3];//(isLarge) ? $child.data('large-h') : $child.data('small-h');
    const childRatio = childW / childH;

    let scale = ( ratio >= childRatio ) ? h/childH : w/childW;

    // adjustments in case scale puts it smaller than maximum
    const scaledW = maxW * scale;
    const scaledH = maxH * scale;

    if( scaledW < w || scaledH < h ) {
      scale = Math.max( w/maxW, h/maxH );
    }

    const offsetLeft = -bounds[0] * scale;
    const offsetTop = -bounds[1] * scale;

    const adjustedHeight = childH * scale;
    const adjustedWidth = childW * scale;


    const top = offsetTop + ((h - adjustedHeight) * 0.5);
    const left = offsetLeft + ((w - adjustedWidth) * 0.5);

    $(el).css(
      {
        "transform": "translate3d(" + left + "px, " + top + "px, 0) scale(" + scale + ")",
        "transform-origin": "top left"
      }
    );

  });

}



// WEBPACK FOOTER //
// ./src/js/proj/handleContainSizing.js